import { Box } from '@mui/material'
import { P2PPrimaryButton } from '../../P2PButtons'
import { stepStyles } from './stepStyles'

interface Props {
  onBack?: () => void
  onContinue: () => void
  backTestId?: string
  continueTestId: string
  continueDisabled?: boolean
}

export const WizardFooter = ({ onBack, onContinue, backTestId, continueTestId, continueDisabled = false }: Props): JSX.Element => (
  <Box sx={stepStyles.footer}>
    {onBack != null &&
      <P2PPrimaryButton onClick={onBack} dataTestId={backTestId}>Back</P2PPrimaryButton>}
    <P2PPrimaryButton onClick={onContinue} disabled={continueDisabled} dataTestId={continueTestId} sx={stepStyles.continueButton}>
      Continue
    </P2PPrimaryButton>
  </Box>
)
